import React from 'react'
import styled from '@emotion/styled'
import { array, bool, object, shape, string } from 'prop-types'

//components import
import { AuthorCard, CardReview, ContentContainer, ContentHeader, RelatedRail } from '@jelly/components'
import { splitParagraphString, useArticle } from '@jelly/utils'

//styled components
const BodyWrapper = styled.div`
	display: block;
	max-width: 90%;
	height: 100%;
	margin: 2rem auto 3rem auto;
	display: flex;
	flex-direction: column;
	${({ theme }) => theme.MQ.M} {
		flex-direction: row;
		margin: 3rem auto 3rem auto;
	}

	${({ theme }) => theme.MQ.XL} {
		${({ theme }) => theme.maxWidth.L};
		width: 100%;
	}
`
const ContentWrapper = styled.article`
	color: ${({ theme }) => theme.colors.text};
	height: 100%;
	width: 100%;
	${({ theme }) => theme.MQ.M} {
		padding-left: 1rem;
		padding-right: 1rem;
		width: 75%;
		display: inline-block;
	}
`
const RightRailComponents = styled.aside`
	margin: auto;
	position: relative;

	${({ theme }) => theme.MQ.M} {
		margin: 0;
		display: inline-block;
		min-width: ${({ hasRightRailContent }) => (hasRightRailContent ? '300px' : '110px')};
		margin-left: 25px;
		right: 0;
	}
`
const ImageCreditWrapper = styled.div`
	padding: 1rem 0.25rem;
	width: 100%;
`
const ImageCredit = styled.div`
	font-size: 9px;
	text-align: right;

	${({ theme }) => theme.MQ.M} {
		font-size: 12px;
	}
`

ReviewBody.propTypes = {
	adsenseMediaQuery: string,
	author: object.isRequired,
	category: object,
	channels: shape({
		primary: object,
		sub: object.isRequired,
	}).isRequired,
	hasAdsense: bool,
	lastModified: string.isRequired,
	pricing: object,
	published: string.isRequired,
	relatedArticles: array,
	relatedBestPicks: array,
	relatedExperts: array,
	relatedReviews: array,
	review: object.isRequired,
	subtitle: string,
	thumbnail: object,
	title: string,
	url: string,
}

export function ReviewBody({
	adsenseMediaQuery,
	author,
	category,
	channels,
	hasAdsense,
	lastModified,
	pricing,
	published,
	relatedArticles,
	relatedBestPicks,
	relatedExperts,
	relatedReviews,
	review: { fullReview, verdict },
	subtitle,
	thumbnail,
	title,
	url,
}) {
	const { hasRightRailContent } = useArticle([relatedArticles, relatedExperts, relatedReviews], true)
	const reviewCard = {
		category,
		pricing,
		thumbnail,
		title,
		verdict,
		url,
	}

	const { caption } = category.thumbnail
	const paragraphs = splitParagraphString(fullReview)
	const [firstParagraph, ...restParagraph] = paragraphs

	return (
		<BodyWrapper>
			<ContentWrapper>
				<ContentHeader
					author={author}
					lastModified={lastModified}
					published={published}
					title={`${title} Review`}
				/>
				<ContentContainer content={firstParagraph} />
				<CardReview linkTo={category} {...reviewCard} />
				<ContentContainer content={restParagraph.join('')} />
				{caption && (
					<ImageCreditWrapper>
						<ImageCredit>Image Credit: {caption}</ImageCredit>
					</ImageCreditWrapper>
				)}
				<CardReview linkTo={category} {...reviewCard} />
				{/* For the rare case that the author fields are null, add conditional check to only show AuthorCard if author object is populated */}
				{author.name && <AuthorCard author={author} />}
			</ContentWrapper>
			<RightRailComponents hasRightRailContent={hasRightRailContent}>
				<RelatedRail
					adsenseMediaQuery={adsenseMediaQuery}
					category={channels}
					hasAdsense={hasAdsense}
					hasRightRailContent={hasRightRailContent} // will have to refactor later on when we want to use a dfp flag
					relatedArticles={relatedArticles}
					relatedBestPicks={relatedBestPicks}
					shouldForceHideReviews={true}
					shouldForceHideExperts={true}
				/>
			</RightRailComponents>
		</BodyWrapper>
	)
}
